import { render, staticRenderFns } from "./LotesDestaque.vue?vue&type=template&id=9b5dd642"
import script from "./LotesDestaque.vue?vue&type=script&lang=js"
export * from "./LotesDestaque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports